import React, {
  FC,
  useState,
  useRef,
  useEffect,
  useCallback,
  PureComponent,
} from 'react'
import { FormattedMessage } from 'react-intl'
import { isAddressComplete } from '@vtex/delivery-packages/dist/address'

import { sanitizedNeighborhood } from '@/checkout-instore-legacy/shipping/utils'
import PostalCodeInput from '../PostalCode/PostalCodeInput'
import AddressForm from '../Address/AddressForm'

export interface InvoiceAddressProps {
  sendInvoiceAddress: (address: Address) => void
  onChangeValidState: (isInvoiceAddressValid: boolean) => void
  onChangeAddress?: (address: Address) => void
  initialAddress?: Address
  logisticsInfo: LogisticsInfo
  countryCode: string
}

export interface InvoiceAddressState {
  address: Address | null
}

const getInitialState = (address?: Address): Address => ({
  street: address?.street || '',
  neighborhood: sanitizedNeighborhood(address?.neighborhood) || '',
  city: address?.city || '',
  state: address?.state || '',
  number: address?.number || '',
  complement: address?.complement || '',
  reference: address?.reference || '',
  postalCode: address?.postalCode || '',
  addressId: address?.addressId || '',
  addressType: address?.addressType || 'residential',
  receiverName: address?.receiverName || '',
  country: address?.country || '',
  geoCoordinates: address?.geoCoordinates || [],
})

const InvoiceAddressFC: FC<InvoiceAddressProps> = ({
  initialAddress,
  logisticsInfo,
  countryCode,
  onChangeValidState,
  onChangeAddress,
}) => {
  const [address, setAddress] = useState(getInitialState(initialAddress))
  const isValid = useRef(null)

  const newIsValid = isAddressComplete(address)
  const currentIsValid = isValid.current
  isValid.current = newIsValid

  if (newIsValid !== currentIsValid) {
    onChangeValidState(newIsValid)
  }

  const handleAddressChange = useCallback(
    (address: Address) => {
      setAddress(address)
      if (onChangeAddress) {
        onChangeAddress(address)
      }
    },
    [onChangeAddress]
  )

  useEffect(
    function reRenderIfInitialValueChanged() {
      handleAddressChange(getInitialState(initialAddress))
    },
    [initialAddress, handleAddressChange]
  )

  return (
    <div className="ph5">
      <div className="pb5">
        <PostalCodeInput
          // TODO: this error popped up when moving the checkout-instore project
          // to checkout-instore-legacy, but needs to be fixed at some point
          // @ts-ignore
          countryCode={countryCode}
          // TODO: this error popped up when moving the checkout-instore project
          // to checkout-instore-legacy, but needs to be fixed at some point
          // @ts-ignore
          initialValue={address.postalCode || ''}
          // TODO: this error popped up when moving the checkout-instore project
          // to checkout-instore-legacy, but needs to be fixed at some point
          // @ts-ignore
          onSubmit={handleAddressChange}
          // TODO: this error popped up when moving the checkout-instore project
          // to checkout-instore-legacy, but needs to be fixed at some point
          // @ts-ignore
          label={<FormattedMessage id="shippingPostalCodeInputLabel" />}
          // TODO: this error popped up when moving the checkout-instore project
          // to checkout-instore-legacy, but needs to be fixed at some point
          // @ts-ignore
          submitOnBlur
        />
      </div>
      <AddressForm
        // TODO: this error popped up when moving the checkout-instore project
        // to checkout-instore-legacy, but needs to be fixed at some point
        // @ts-ignore
        onAddressChange={handleAddressChange}
        // TODO: this error popped up when moving the checkout-instore project
        // to checkout-instore-legacy, but needs to be fixed at some point
        // @ts-ignore
        address={address}
        // TODO: this error popped up when moving the checkout-instore project
        // to checkout-instore-legacy, but needs to be fixed at some point
        // @ts-ignore
        logisticsInfo={logisticsInfo}
        // TODO: this error popped up when moving the checkout-instore project
        // to checkout-instore-legacy, but needs to be fixed at some point
        // @ts-ignore
        allowCollapsed={false}
      />
    </div>
  )
}

class InvoiceAddress extends PureComponent<
  InvoiceAddressProps,
  InvoiceAddressState
> {
  constructor(props: InvoiceAddressProps) {
    super(props)

    this.state = {
      address: null,
    }
  }

  handleSubmit = () => {
    if (this.state.address) {
      this.props.sendInvoiceAddress(this.state.address)
    }
  }

  handleChangeAddress = (address: Address) => this.setState({ address })

  render() {
    return (
      <InvoiceAddressFC
        {...this.props}
        onChangeAddress={this.handleChangeAddress}
      />
    )
  }
}

export default InvoiceAddress
